import {updateItems} from 'constants/addcustomer.constants';

import { useLocation,matchPath  } from 'react-router-dom';
import { useSelector } from 'react-redux';



import { FaCheck } from "react-icons/fa";

 

const SiderbarCustomer = () => {

      const { steps } = useSelector(state => state.customer);


  
    const location = useLocation();
  const checkIsActive = (path, exact) => {
    return matchPath({ path, end: exact }, location.pathname) !== null;
  };


  return (
      <div className=" w-full lg:w-[25%]  h-fit lg:h-screen border static lg:sticky top-0 bg-white">
          <ul className="py-4 pl-3 lg:pl-0 flex flex-wrap gap-3 lg:flex-col lg:gap-1">
            {updateItems.map((item) => {
                               const isActive = checkIsActive(item.path, item.exact);
              return (
                <li key={item.id}>
                  <div
            
                    className={`flex flex-row  justify-center w-fit lg:w-full lg:justify-start items-center px-6 lg:px-0 py-3 pl-2 lg:pl-5 gap-2 text-sm cursor-pointer transition-all group
                      ${
                        isActive
                          ? "text-primary bg-gray1  rounded-full lg:rounded-[0px]  lg:border-secondary lg:border-r-2"
                          : "text-dark1 hover:text-primary"
                      }
                    `}
                  >
                  <item.icon 
                                    className={`w-[18px] 
                                      
                                    `} 
                                    />
                    <p>{item.name}</p>

                 
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
  )
}

export default SiderbarCustomer;



